import DesktopPorfolioPage from '.';
import DesktopGuard from '@/components/auth/desktop/DesktopGuard';
import ActionsPortfolio from './ActionsPortfolio';
import PortfolioOverview from './PortfolioOverview';
import ReferralBanner from './ReferralBanner';
import UserCash from './UserCash';
export default function PortfolioLayout() {
  return <div className='hidden lg:flex flex-row gap-4 p-4 h-full' data-sentry-component="PortfolioLayout" data-sentry-source-file="PortfolioLayout.tsx">
      <div className='h-full w-[65%]'>
        <DesktopPorfolioPage data-sentry-element="DesktopPorfolioPage" data-sentry-source-file="PortfolioLayout.tsx" />
      </div>
      <div className='w-[35%] flex flex-col gap-4'>
        <DesktopGuard data-sentry-element="DesktopGuard" data-sentry-source-file="PortfolioLayout.tsx">
          <ActionsPortfolio data-sentry-element="ActionsPortfolio" data-sentry-source-file="PortfolioLayout.tsx" />
          <UserCash data-sentry-element="UserCash" data-sentry-source-file="PortfolioLayout.tsx" />
          <div className='flex flex-col gap-2 genius-shadow p-3 bg-genius-indigo rounded-[20px] border-genius-blue border-[1px] overflow-hidden'>
            <p className='text-[20px]'>Overview</p>
            <PortfolioOverview data-sentry-element="PortfolioOverview" data-sentry-source-file="PortfolioLayout.tsx" />
          </div>
          <div className='flex-1 flex'>
            <ReferralBanner small data-sentry-element="ReferralBanner" data-sentry-source-file="PortfolioLayout.tsx" />
          </div>
        </DesktopGuard>
      </div>
    </div>;
}